"use strict";

/** @format */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.positionIconArgType = void 0;
exports.positionIconArgType = {
  name: 'positionIcon',
  options: ['left', 'right'],
  control: {
    type: 'select'
  },
  description: 'The position of the icon in the button'
};
